import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";

const quickLinks = [
  { label: "Hospedagem", to: "/hospedagem", icon: "ri-server-line" },
  { label: "VPS", to: "/vps", icon: "ri-cloud-line" },
  { label: "Criação de Sites", to: "/sites", icon: "ri-window-2-line" },
  { label: "Domínios", to: "/dominios", icon: "ri-global-line" },
  { label: "Blog", to: "/blog", icon: "ri-article-line" },
  { label: "Contato", to: "/contato", icon: "ri-customer-service-2-line" },
];

export default function NotFound() {
  return (
    <SiteLayout>
      <Seo
        title="Página não encontrada (404) | NXHOST"
        description="A página que você procura não existe ou foi movida. Volte para a página inicial da NXHOST ou explore hospedagem, VPS, criação de sites e domínios."
        path="/404"
        noindex
      />

      <section className="relative overflow-hidden bg-background-50 pt-36 pb-20 md:pt-44 md:pb-28">
        <div className="mx-auto flex max-w-3xl flex-col items-center px-4 text-center md:px-8">
          <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-100 text-primary-700">
            <i className="ri-compass-3-line text-3xl" aria-hidden="true"></i>
          </span>

          <p className="mt-6 font-heading text-6xl font-bold tracking-tight text-foreground-950 md:text-8xl">
            404
          </p>

          <h1 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            Não encontramos esta página.
          </h1>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            O endereço que você tentou acessar não existe, mudou de lugar ou está fora do ar. Mas
            sem problema — use os atalhos abaixo para continuar navegando.
          </p>

          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line" aria-hidden="true"></i>
              Voltar para o início
            </Link>
            <Link
              to="/contato"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100"
            >
              <i className="ri-chat-3-line" aria-hidden="true"></i>
              Falar com um especialista
            </Link>
          </div>
        </div>

        <div className="mx-auto mt-14 max-w-4xl px-4 md:px-8">
          <p className="mb-4 text-center text-xs font-semibold uppercase tracking-wide text-foreground-500">
            Acesso rápido
          </p>
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
            {quickLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="group flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 px-4 py-3.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:bg-background-100"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                  <i className={link.icon} aria-hidden="true"></i>
                </span>
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}